/* eslint-disable */

import React from "react";
import { useCallback } from "react";
import { useMemo } from "react";
import { isEmptyObject, isValidResponse } from "./Screens/CommonUtils";

const FINANCIAL_SCOPES = ["CustomerAdmin", "CustomerEmployee", "EdgeAdmin", "EdgeEmployee", "EdgeHREmployee"];

export const usePermissions = (props) => {
  const loggedInUserType = useMemo(() => {
    let loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));

    if (isEmptyObject(loggedInUser)) {
      return loggedInUser?.type;
    }
  }, []);

  const loggedInUser = useMemo(() => {
    return JSON.parse(localStorage.getItem("loggedInUser"));
  }, []);

  const userAdditionalInfo = useMemo(() => {
    return JSON.parse(localStorage.getItem("loggedInUser"));
  }, []);

  const dropdownData = useMemo(() => {
    return JSON.parse(sessionStorage.getItem("dropdownData"));
  }, []);

  const accessToken = useMemo(() => {
    return localStorage.getItem("accessToken");
  }, []);

  const canRead = useCallback((module) => {
    switch (module) {
      case "searchBar":
        if (loggedInUserType === "customer") {
          return true;
        } else if (loggedInUserType === "edge") {
          return true;
        } else {
          return false;
        }
    }
  }, []);

  const hasPermission = useCallback((scope) => {
    const user = JSON.parse(localStorage.getItem("loggedInUser"));
    return Array.isArray(user?.permissions) && user.permissions.includes(scope);
  }, []);

  /**
   * @deprecated Checks the legacy coarse role-flag array (FINANCIAL_SCOPES), not RBAC.
   * Use `hasPermission("payroll.read")` from `hooks/usePermission` instead.
   */
  const canAccessFinancials = useCallback(() => {
    const user = JSON.parse(localStorage.getItem("loggedInUser"));
    if (!Array.isArray(user?.permissions)) return false;
    return user.permissions.some((p) => FINANCIAL_SCOPES.includes(p));
  }, []);

  return {
    canRead,
    hasPermission,
    canAccessFinancials,
    loggedInUserType,
    loggedInUser: isEmptyObject(loggedInUser) ? loggedInUser : {},
    userAdditionalInfo: isEmptyObject(userAdditionalInfo) ? userAdditionalInfo : {},
    dropdownData: isValidResponse(dropdownData) ? dropdownData : {},
    accessToken: accessToken,
  };
};

// export default Hook;
